<h3>заказанное ранее</h3>


<div *ngFor="let item of goods">
  <!-- client?.priceType ?? -->
  <app-edit-order-select-goods-item [item]="item" [priceTypes]="client?.priceTypes"></app-edit-order-select-goods-item>
</div>